import { useEffect, useRef } from 'react';

const uid = () => { try { return JSON.parse(localStorage.getItem('user') || '{}').id || 'anon'; } catch { return 'anon'; } };
export const newId = () => Math.random().toString(16).slice(2, 14).padEnd(12, '0');
export const snap = (items, sem, obs) => JSON.stringify({ items, sem, obs: obs || '' });
export const backupKey = (k) => `dnamapa:ficha:${uid()}:${k.studentId}:${k.classId}:${k.subjectId}:${k.period}:${k.year}`;

export const readBackup = (key) => { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch { return null; } };
export const writeBackup = (key, v) => { try { localStorage.setItem(key, JSON.stringify({ ...v, at: new Date().toISOString() })); } catch { /* armazenamento cheio */ } };
export const clearBackup = (key) => { try { localStorage.removeItem(key); } catch { /* noop */ } };

/** O que falta para concluir a ficha: obrigatórios bloqueiam “Registrar”; recomendados apenas orientam. */
export function missingOf(items, sem) {
  if (sem) return { req: [], rec: [] };
  if (!items.length) return { req: ['Registre ao menos uma dificuldade ou marque “Sem dificuldade observada”.'], rec: [] };
  const req = [];
  const rec = [];
  items.forEach((it, i) => {
    const n = `Registro #${i + 1}`;
    if (!it.skill_code && !(it.conteudo || '').trim()) req.push(`${n}: habilidade BNCC ou conteúdo`);
    if (!(it.evidencia || '').trim()) req.push(`${n}: evidência observada`);
    if (!it.prioridade) req.push(`${n}: prioridade`);
    if (!it.autonomia) rec.push(`${n}: grau de autonomia`);
    if (!it.intensidade) rec.push(`${n}: intensidade`);
    if (it.reforco && !(it.estrategia || '').trim()) rec.push(`${n}: estratégia para o reforço`);
  });
  return { req, rec };
}

/** Salvamento automático de rascunho (somente após alteração real) e aviso ao sair da página. */
export function useAutosave({ dirty, enabled, save, delay = 4000 }) {
  const t = useRef();
  useEffect(() => {
    clearTimeout(t.current);
    if (dirty && enabled) t.current = setTimeout(save, delay);
    return () => clearTimeout(t.current);
  }, [dirty, enabled, save, delay]);
  useEffect(() => {
    if (!dirty) return undefined;
    const h = (e) => { e.preventDefault(); e.returnValue = ''; };
    window.addEventListener('beforeunload', h);
    return () => window.removeEventListener('beforeunload', h);
  }, [dirty]);
}
